<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn text rounded color="primary" :to="{name: 'ProdutosLista'}" exact>
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      <!-- </v-toolbar-items> -->

      <v-spacer></v-spacer>

      <template v-slot:actions>
        <v-btn
          text
          rounded
          :disabled="salvando"
          @click="$router.push({name: 'ProdutosLista'})"
        >Cancelar</v-btn>
        <v-btn depressed rounded color="primary" @click="confirmar" :loading="salvando" :disabled="!form_valido">Salvar</v-btn>
      </template>
    </z-centralized-toolbar>

    <z-container>
      <!-- <h3 class="headline mb-3">{{ titulo }} Produto</h3> -->

      <v-tabs v-model="tab" background-color="transparent" color="primary">
        <v-tab>Dados do Produto</v-tab>
        <v-tab>Fornecedores</v-tab>
        <v-tab>Variações</v-tab>
      </v-tabs>
      <v-divider class="mb-2"></v-divider>

      <v-tabs-items v-model="tab" class="transparent pa-1">

        <v-tab-item v-bind="$v.TABS_CONFIG">

          <v-card>
            <v-card-title class="text-subtitle-2">
              Dados do Produto
            </v-card-title>
            <v-divider></v-divider>

            <!-- <z-loading :loading="$store.state.loading" height="100px" color="primary"></z-loading> -->

            <v-card-text>
              <v-form ref="form" v-model="form_valido" lazy-validation>
                <!-- <v-row dense>
                    <h3 class="subheader">Cliente</h3>
                  </v-row> -->
                <v-row dense>
                  <v-col cols="12" sm="3">
                    <z-text-field
                      v-model="produto.referencia"
                      label="Referência Loja *"
                      autofocus
                      outlined
                      dense
                      :rules="[rules.campoObrigatorio, rules.referenciaValida]"
                      :disabled="!podeAlterarReferencia"
                      :readonly="!podeAlterarReferencia"
                      :loading="referencia_loading"
                    >
                      <template #append v-if="podeAlterarReferencia">
                        <v-tooltip bottom>
                          <template #activator="{ on, attrs }">
                            <!-- <v-btn icon :loading="referencia_loading" v-bind="attrs" v-on="on"> -->
                              <v-icon color="primary" @click.stop="gerarReferencia" v-bind="attrs" v-on="on">mdi-barcode</v-icon>
                            <!-- </v-btn> -->
                          </template>
                          <span>Gerar uma nova referência</span>
                        </v-tooltip>
                      </template>
                    </z-text-field>
                  </v-col>

                  <v-col cols="12" sm="9">
                    <z-text-field
                      v-model="produto.descricao"
                      label="Descrição Loja *"
                      filled
                      dense
                      upper
                      :rules="[rules.campoObrigatorio]"
                    ></z-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="3">
                    <z-text-field
                      v-model="produto.referencia_fornecedor"
                      label="Referência Fornecedor"
                      filled
                      dense
                    ></z-text-field>
                  </v-col>

                  <v-col cols="12" sm="9">
                    <z-text-field
                      v-model="produto.descricao_fornecedor"
                      label="Descrição Fornecedor"
                      filled
                      dense
                      upper
                    ></z-text-field>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="3">
                    <z-text-field
                      v-model="produto.codigo_barras"
                      label="Código de Barras"
                      hint="Opicional"
                      maxlength="13"
                      persistent-hint
                      filled
                      dense
                    >
                      <template #append>
                        <v-tooltip bottom>
                          <template #activator="{ on, attrs }">
                            <v-icon color="primary" @click.stop="gerarCodigoBarras" v-bind="attrs" v-on="on">mdi-barcode-scan</v-icon>
                          </template>
                          <span>Gerar um código de barras EAN13</span>
                        </v-tooltip>
                      </template>
                    </z-text-field>
                  </v-col>

                  <v-col cols="12" sm="9">
                    <v-row dense>

                      <v-col cols="12" sm="3">
                        <z-select
                          v-model="produto.unidade"
                          label="Unidade"
                          filled
                          :items="$globals.UNIDADES"
                        ></z-select>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <z-campo-valor
                          v-model="produto.estoque_minimo"
                          label="Estoque Mínimo"
                          decimais="0"
                          filled
                        ></z-campo-valor>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <z-campo-valor
                          v-model="produto.valor_custo"
                          label="Valor Custo"
                          filled
                        ></z-campo-valor>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <z-campo-valor
                          v-model="produto.valor_venda"
                          label="Valor Venda"
                          filled
                          :rules="[rules.maiorQueZero]"
                        ></z-campo-valor>
                      </v-col>

                    </v-row>

                  </v-col>
                  <v-col cols="12" sm="2"  v-if="false">
                    <z-campo-valor
                      v-model="produto.valor_venda_prazo1"
                      label="Valor a prazo"
                      filled
                      dense
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="12" sm="2" v-if="false">
                    <z-campo-valor
                      v-model="produto.estoque_inicial"
                      label="Estoque Inicial"
                      filled
                      dense
                      :decimais="0"
                      :disabled="!!produto.id"
                    ></z-campo-valor>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="3">
                    <v-select
                      label="Grupo"
                      v-model="produto.produto_grupo_id"
                      filled
                      dense
                      :items="$store.getters['listas/grupos']"
                      :rules="[rules.campoObrigatorio]"
                    >
                      <template #append-outer>
                        <v-icon color="primary" @click="$refs.dialogoAdicionarGrupo.abrir()">mdi-plus</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <!-- <v-col cols="12" sm="9">
                    <v-autocomplete
                      v-model="produto.fornecedor_id"
                      label="Fornecedor"
                      clearable
                      filled
                      dense
                      :items="$store.getters['listas/fornecedores']"
                    ></v-autocomplete>
                  </v-col> -->
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="12">
                    <z-textarea
                      v-model="produto.observacoes"
                      label="Observações"
                      filled
                      dense
                    ></z-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
              <v-switch
                v-model="produto.ativo"
                color="primary"
                label="Ativo"
                hide-details
                filled
                dense
              ></v-switch>
            </v-card-actions>
          </v-card>

        </v-tab-item>

        <v-tab-item v-bind="$v.TABS_CONFIG">
            <v-card>
              <v-toolbar flat dense>
                <v-toolbar-title class="text-subtitle-2">Fornecedores</v-toolbar-title>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text>
                
                <v-list two-line>
                  <template v-for="(fornecedor, index) in produto.fornecedores">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>{{ fornecedor.text }}</v-list-item-title>
                        <v-list-item-subtitle class="text--primary">{{ fornecedor.celular }}</v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <z-delete
                          titulo="Remover Fornecedor"
                          botaoSim="Remover"
                          botaoNao="Cancelar"
                          cor-botao-sim="red"
                          :loading="removendo"
                          @click:sim="confirmarRemover(fornecedor, index)"
                        >
                          O fornecedor será removido do produto. Deseja continuar?
                        </z-delete>

                        <!-- <v-icon>mdi-delete</v-icon> -->
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index < produto.fornecedores.length-1"></v-divider>
                  </template>
                </v-list>

                  <adicionar-fornecedor
                    v-show="adicionar_fornecedor"
                    :fornecedores="fornecedores"
                    @adicionar:fornecedor="toggleFornecedor"
                    @cancelar:fornecedor="adicionar_fornecedor = false"
                  >
                  </adicionar-fornecedor>      
                
              </v-card-text>

              <template v-show="!adicionar_fornecedor">
                <v-divider v-if="produto.fornecedores.length > 0"></v-divider>
                <v-card-actions v-show="!adicionar_fornecedor" class="pa-4">
                  <v-btn depressed color="primary" @click="adicionar_fornecedor = true">Adicionar Fornecedor</v-btn>
                </v-card-actions>
              </template>
            </v-card>
        </v-tab-item>

        <v-tab-item v-bind="$v.TABS_CONFIG">
          <variacoes-produto></variacoes-produto>
        </v-tab-item>

      </v-tabs-items>



      <!-- <z-visibility :visible="!config.IS_PRODUCTION"> -->
        <!-- <variacoes-produto class="mt-5" v-if="produto.id"></variacoes-produto> -->
      <!-- </z-visibility> -->
    </z-container>

    <grupos-form ref="dialogoAdicionarGrupo" @grupo:salvar="onGrupoSalvar"></grupos-form>

  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import VariacoesProduto from './variacoes/VariacoesProduto';
import GruposForm from "./grupos/GruposForm.vue";
import AdicionarFornecedor from "./AdicionarFornecedor.vue";
import config from "@/app/config";
import * as rules from "@/app/helpers/validacoes";
import queryBuilder from '@/app/helpers/QueryBuilder';


import produtosApi from "@/app/services/produtos";
import fornecedores from "../../app/store/modules/fornecedores";

export default {
  name: "produtos-form",
  
  components: { 
    VariacoesProduto,
    GruposForm,
    AdicionarFornecedor
  },

  data() {
    return {
      config: config,
      form_valido: false,
      produto: {
        referencia: null,
        unidade: "UN",
        ativo: true,
        estoque_inicial: 0,
        valor_venda: 0,
        produto_grupo_id: 1,
        codigo_barras: "",
        fornecedores: []
      },
      salvando: false,
      rules: rules,
      tab: "",
      referencia_loading: false,
      barcode_loading: false,
      adicionar_fornecedor: false,
      removendo: false,       
    };
  },

  computed: {
    ...mapGetters("listas", ["grupos"]),
    titulo() {
      let titulo = this.$route.meta.editando ? "Editar" : "Adicionar";
      return titulo + " " + "Produto";
    },

    configuracoes() {
      return this.$store.state.configuracoes;
    },

    podeAlterarReferencia() {
      if (this.$route.name == "ProdutosEditar") {
        return this.configuracoes.APP_ALTERAR_REF_PROD && this.$auth.can("produtos:alterar_referencia_produto");
      }

      return true;
    },

    fornecedores() {
      const produtoFornecedoresIds = this.produto.fornecedores.map(fornecedor => fornecedor.id);
      return this.$store.state.listas.fornecedores.filter(fornecedor => !produtoFornecedoresIds.includes(fornecedor.value));
    }

  },

  beforeRouteLeave(to, from, next) {
    this.UNSET_PRODUTO();
    next();
  },

  async beforeMount() {
    await this.$store.dispatch("listas/fetchListas", [
      queryBuilder()
        .from("Fornecedor")
        .selectraw("id as value, CONCAT(id, ' - ', razao) as text, celular, telefone, id, razao")
        .orderBy("razao")
        .build(),
    ]);
    // await this.$store.dispatch("listas/fornecedores");
    await this.$store.dispatch("listas/lotes");
    await this.$store.dispatch("listas/grupos");
  },

  async mounted() {
    this.setTitulo(this.titulo);
    if (this.$route.name == "ProdutosEditar") {
      if (!this.$store.state.produtos.produto.id) {
        if (this.$route.params.id) {
          await this.abrir(this.$route.params.id);
          await this.$store.dispatch('produtos/variacoes', this.$route.params.id);
        }
      }
      this.produto = this.clone(this.$store.state.produtos.produto);
    }
    //  else {
    //   await this.$store.dispatch("produtos/proximaReferencia");
    //   this.produto.referencia = this.$store.state.produtos.proxima_referencia;
    // }
  },

  methods: {
    ...mapMutations(["setTitulo"]),
    ...mapMutations("produtos", ["UNSET_PRODUTO"]),
    ...mapActions("produtos", ["abrir", "atualizar", "salvar"]),

    async confirmar() {
      if (this.$refs.form.validate()) {
        try {
          this.salvando = true;

          if (this.$route.params.id) {
            await this.atualizar(this.produto);
          } else {
            await this.salvar(this.produto);
          }
          this.$router.push({ path: "/catalogo/produtos" });
          this.$eventbus.notificar("Produto salvo com sucesso");
        } catch (error) {
          this.$eventbus.erro(
            "Não foi possível salvar esse produto. Verifique os dados inseridos.",
            error
          );
        } finally {
          this.salvando = false;
        }
      }
    },

    async gerarReferencia() {
      try {
        this.referencia_loading = true;
        const { referencia } = await produtosApi.gerarReferencia();
        this.produto.referencia = referencia;
      } catch (error) {
        this.$eventbus.erro("Não foi possível gerar o código de barras", error);
        throw error;
      } finally {
        this.referencia_loading = false;
      }
    },

    async gerarCodigoBarras() {
      try {
        this.barcode_loading = true;
        const { codigo } = await produtosApi.gerarCodigoBarras({
          produto_id: this.produto.id,
          tipo: "EAN13",
        });
        this.produto.codigo_barras = codigo;
      } catch (error) {
        this.$eventbus.erro("Não foi possível gerar o código de barras", error);
        throw error;
      } finally {
        this.barcode_loading = false;
      }
    },

    onGrupoSalvar(grupo) {
      console.log("Grupo salvo", grupo);
      this.produto.produto_grupo_id = grupo.id;
      this.$store.dispatch("listas/grupos");
    },

    async confirmarRemover(fornecedor) {
      try {
        await this.$axios.post(`/produtos/${this.produto.id}/fornecedor`, {
          fornecedor_id: fornecedor.id,
        });

        this.produto.fornecedores = this.produto.fornecedores.filter((f) => f.id !== fornecedor.id);
        this.adicionar_fornecedor = false; 

        this.$eventbus.notificar("Fornecedor removido com sucesso");
      } catch (error) {
        this.$eventbus.erro("Não foi possível remover o fornecedor", error);
        throw error;
      }
    },

    async toggleFornecedor(fornecedor) {
      try {
        await this.$axios.post(`/produtos/${this.produto.id}/fornecedor`, {
          fornecedor_id: fornecedor.id,
        });

        this.produto.fornecedores.push(fornecedor);
        this.adicionar_fornecedor = false; 

        this.$eventbus.notificar("Fornecedor adicionado com sucesso");
      } catch (error) {
        this.$eventbus.erro("Não foi possível adicionar o fornecedor", error);
        throw error;
      }

    },
  },


};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */
</style>
